import {autoRegister, resolve} from "../../../container";
import {PageScrollbar} from "../../../common/pageScrollbar";
import {PageFeatures} from "../pageFeatures";
import {EventBus, EventBusEvent} from "../../../common/eventBus";
import {DIALOG_CLOSED_EVENT, DIALOG_OPENED_EVENT, type EopDialog} from "./dialog";
import {generateUuid} from "../../../common/crypto";
import {elementFrom} from "../../../common/utils/html";

@autoRegister()
export class Dialogs {

    public constructor(
        private pageScrollbar: PageScrollbar = resolve(PageScrollbar),
        private pageFeatures: PageFeatures = resolve(PageFeatures),
        eventBus: EventBus = resolve(EventBus)
    ) {
        eventBus.on(DIALOG_CLOSED_EVENT, () => this.enablePageScrollbar());
        eventBus.on(DIALOG_OPENED_EVENT, event => this.closeOtherDialogs(event));
    }

    public async open(dialogId: string): Promise<void> {
        const dialog = this.pageFeatures.findFirst<EopDialog>(`eop-dialog[id='${dialogId}']`);
        if (dialog) {
            await dialog.showModal();
            this.pageScrollbar.disablePageScrollability();
        }
    }

    public createFromHtml(dialogContent: string): string {
        const dialog = this.createDialog();
        dialog.querySelector(".dialog-content")!.innerHTML = dialogContent;
        return this.insertDialog(dialog);
    }

    public createFromElement(dialogContent: HTMLElement): string {
        const dialog = this.createDialog();
        dialog.querySelector(".dialog-content")!.appendChild(dialogContent);
        return this.insertDialog(dialog);
    }

    private createDialog(): EopDialog {
        const dialogId = generateUuid();
        return elementFrom<EopDialog>(`
            <eop-dialog id="${dialogId}">
                <div eop-slot="dialog-content" class="dialog-content"></div>
            </eop-dialog>
        `);
    }

    private insertDialog(dialog: EopDialog): string {
        this.pageFeatures.insert(dialog);
        return dialog.id;
    }

    private closeOtherDialogs(event: EventBusEvent): void {
        const openingDialog = event.data as EopDialog;
        this.allDialogs()
            .filter(dialog => dialog.id !== openingDialog.id)
            .filter(dialog => dialog.isOpen())
            .forEach(dialog => dialog.close());
    }

    private enablePageScrollbar(): void {
        if (this.noOpenDialog()) {
            this.pageScrollbar.enablePageScrollability();
        }
    }

    private noOpenDialog(): boolean {
        return this.allDialogs()
            .filter(dialog => dialog.isOpen())
            .isEmpty();
    }

    private allDialogs(): EopDialog[] {
        return Array.from(this.pageFeatures.find<EopDialog>("eop-dialog"));
    }
}